export default __webpack_public_path__ + "scene5_4_iconc2d4f9.png";